import React from 'react'
import { Link } from 'react-router-dom'
import { Image, Grid, Container, List, Form, Icon } from 'semantic-ui-react'

function Footer() {
  return (
    <div className="easyfooter-container">
      <Container fluid style={styles.container} className="easyfooter">

        <div style={styles.footerLogo}>
          <Image alt="logo-white" src="/img/logo-white.png" size="small" />

          <div style={{ flexDirection: "row" }}>
            <a href="https://www.facebook.com/easysalemalta"
              rel="noopener" target="_blank" style={{ paddingRight: '8px' }}
            ><strong style={{ color: 'black' }}>'
              </strong><Icon name="facebook" /></a>

            <a href="https://www.instagram.com/easysale.malta"
              rel="noopener" target="_blank" style={{ paddingRight: '8px' }}
            ><strong style={{ color: 'black' }}>'</strong>
              <Icon name="instagram" /></a>

          </div>
        </div>

        <Grid container>
          <Grid.Column computer={"4"} mobile="16">
            <h3>Properties</h3>
            <List>
              <List.Item><Link target="_blank" to="/luxury-villas-for-sale-in-malta">Luxury Villas For Sale in Malta</Link></List.Item>
              <List.Item><Link target="_blank" to="/townhouses-for-sale-in-malta">Townhouses For Sale in Malta</Link></List.Item>
              <List.Item><Link target="_blank" to="/penthouses-for-sale-in-malta">Penthouses For Sale in Malta</Link></List.Item>
              <List.Item><Link target="_blank" to="/maisonettes-for-sale-in-malta">Maisonettes For Sale in Malta</Link></List.Item>
              <List.Item><Link target="_blank" to="/apartments-for-sale-in-malta">Apartments For Sale in Malta</Link></List.Item>
              <List.Item><Link target="_blank" to="/farmhouses-for-sale-in-malta">Farmhouses For Sale in Malta</Link></List.Item>
              <List.Item><Link target="_blank" to="/terraced-houses-for-sale-in-malta">Terraced Houses For Sale in Malta</Link></List.Item>
              <List.Item><Link target="_blank" to="/houses-of-character-for-sale-in-malta">Houses of Character For Sale in Malta</Link></List.Item>
              <List.Item><Link target="_blank" to="/seafront-property-for-sale-in-malta">Seafront Property For Sale in Malta</Link></List.Item>
              <List.Item><Link target="_blank" to="/bars-for-sale-in-malta">Bars For Sale in Malta</Link></List.Item>
              <List.Item><Link target="_blank" to="/offices-for-sale-in-malta">Offices For Sale in Malta</Link></List.Item>
              <List.Item><Link target="_blank" to="/bungalows-for-sale-in-malta">Bungalows For Sale in Malta</Link></List.Item>
              <List.Item><Link target="_blank" to="/boathouse-for-sale-in-malta">Boathouse For Sale in Malta</Link></List.Item>
              <List.Item><Link target="_blank" to="/garage-for-sale-in-malta">Garage For Sale in Malta</Link></List.Item>
              <List.Item><Link target="_blank" to="/hotels-for-sale-in-malta">Hotels For Sale in Malta</Link></List.Item>
            </List>
          </Grid.Column>
          <Grid.Column computer={"4"} mobile="16">
            <h3>Locations</h3>
            <List>
              <List.Item><Link target="_blank" to="/property-for-sale-in-sliema">Property For Sale in Sliema</Link></List.Item>
              <List.Item><Link target="_blank" to="/property-for-sale-in-valletta">Property For Sale in Valletta</Link></List.Item>
              <List.Item><Link target="_blank" to="/property-for-sale-in-swieqi">Property For Sale in Swieqi</Link></List.Item>
              <List.Item><Link target="_blank" to="/property-for-sale-in-naxxar">Property For Sale in Naxxar</Link></List.Item>
              <List.Item><Link target="_blank" to="/property-for-sale-in-ta-xbiex">Property For Sale in Ta'Xbiex</Link></List.Item>
              <List.Item><Link target="_blank" to="/property-for-sale-in-san-gwann">Property For Sale in San Gwann</Link></List.Item>
              <List.Item><Link target="_blank" to="/property-for-sale-in-rabat">Property For Sale in Rabat</Link></List.Item>
              <List.Item><Link target="_blank" to="/property-for-sale-in-madliena">Property For Sale in Madliena</Link></List.Item>
              <List.Item><Link target="_blank" to="/property-for-sale-in-st-pauls-bay">Property For Sale in St. Paul's Bay</Link></List.Item>
              <List.Item><Link target="_blank" to="/property-for-sale-in-st-julians">Property For Sale in St. Julian's</Link></List.Item>
              <List.Item><Link target="_blank" to="/property-for-sale-in-mellieha">Property For Sale in Mellieha</Link></List.Item>
              <List.Item><Link target="_blank" to="/property-for-sale-in-gozo">Property For Sale in Gozo</Link></List.Item>
              <List.Item><Link target="_blank" to="/property-for-sale-in-cental-malta">Property For Sale in Central, Malta</Link></List.Item>
              <List.Item><Link target="_blank" to="/property-for-sale-in-south-malta">Property For Sale in South, Malta</Link></List.Item>
              <List.Item><Link target="_blank" to="/property-for-sale-in-north-malta">Property For Sale in North, Malta</Link></List.Item>
            </List>
          </Grid.Column>
          <Grid.Column computer={"3"} mobile="16">
            <h3>About Us</h3>
            <List>
              <List.Item><Link to="/">Home</Link></List.Item>
              <List.Item><Link to="/company">Company</Link></List.Item>
              <List.Item><Link to="/career">Careers</Link></List.Item>
              <List.Item><Link to="/contact">Contact Us</Link></List.Item>
            </List>
            <h3>Quick Links</h3>
            <List>
              <List.Item><Link to="/residentials">Residential Properties</Link></List.Item>
              <List.Item><Link to="/commercials">Commercial Properties</Link></List.Item>
            </List>
            <h3>Contact</h3>
            <List>
              <List.Item>
                <List.Icon name='marker' />
                <List.Content>420 Triq D'Argens, Il-Gżira</List.Content>
              </List.Item>
              <List.Item>
                <List.Icon name='phone' />
                <List.Content><a href="tel:99998330">99998330</a></List.Content>
              </List.Item>
              <List.Item>
                <List.Icon name='mail' />
                <List.Content><a href="mailto:info@easysale.com.mt">info@easysale.com.mt</a>
                </List.Content>
              </List.Item>

            </List>
          </Grid.Column>
          <div style={{ display: 'flex', flex: 1, justifyContent: 'center' }}>
            <Grid.Column computer={"3"} mobile="16">
              <h3>Newsletter</h3>
              <List>
                <List.Item>Sign up and we'll send the best deals to you.</List.Item>
              </List>
              <Form>
                <Form.Group>
                  <Form.Input
                    placeholder='Email'
                    name='name'
                  />
                  <Form.Button color="orange" content='Register' />
                </Form.Group>
              </Form>
            </Grid.Column>
          </div>

        </Grid>
      </Container>
    </div>
  )
}

export default Footer

const styles = {
  container: {

  }, footerLogo: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 5,
    flexDirection: "column",
    flex: 1
  }

}